import { LuChevronRight } from 'react-icons/lu'
import { Flex, Text } from '@chakra-ui/react'
import { getValidTranslation } from '@leid/api-products'

import i18n from 'utils/i18n'
import { normalizeUrl } from 'utils/normalizeUrl'
import { Category } from 'app/utils/helpers/helpers'

export const getCategoryName = (category: Category): string => {
  const lang = i18n.language === 'no' ? 'nb-NO' : 'en-US'
  const name = getValidTranslation(lang, category.nameTranslations)?.translation ?? ''
  return name
}

const getParentCategoriesChain = (
  category: Category,
  allCategories: Category[],
  categoriesChain: Category[] = [],
): Category[] => {
  if (category.parentCategoryId === undefined) {
    categoriesChain.push(category)
    return categoriesChain
  }

  const parentCategory = allCategories.find((s) => s.id === category.parentCategoryId)
  if (!parentCategory) {
    return categoriesChain
  }

  const updatedChain = getParentCategoriesChain(parentCategory, allCategories, categoriesChain)
  updatedChain.push(category)
  return updatedChain
}

export const getCategoryURL = (category: Category, allCategories: Category[]): string => {
  const parts = getCategoryURLParts(category, allCategories)
  const url = `/browse/${parts}`
  return url
}

export const getCategoryURLParts = (category: Category, allCategories: Category[]): string => {
  const categoriesChain = getParentCategoriesChain(category, allCategories)

  const parts = categoriesChain.map((s) =>
    normalizeUrl(getValidTranslation('', s.nameTranslations)?.translation ?? '', s.id),
  )
  return parts.join('/')
}

export const getCategoryButton = (category: Category, hasChildren: boolean): JSX.Element => {
  return (
    <Flex
      alignItems="center"
      flexDirection="row"
      width="100%"
      gap={6}
      style={{
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingTop: '10px',
        paddingBottom: '10px',
        cursor: 'pointer',
      }}
    >
      {category.imageUrl && (
        <>
          <Flex height="28px" width="28px" alignItems="center">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={category.imageUrl} alt="" width="28px" height="28px" style={{ objectFit: 'contain' }} />
          </Flex>
        </>
      )}
      <span style={{ textAlign: 'start', margin: 'auto', marginLeft: 0 }}>
        <Text fontSize={{ base: 'md', lg: 'sm' }} color="black">
          {getCategoryName(category)}
        </Text>
      </span>
      {hasChildren && (
        <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <LuChevronRight size={24} />
        </span>
      )}
    </Flex>
  )
}
